import { useCallback, useEffect, useMemo, useRef } from 'react';
export default function useRafLoop(cb, initiallyActive = true) {
  const raf = useRef(null);
  const rafActivity = useRef(false);
  const rafCallback = useRef(cb);
  rafCallback.current = cb;
  const step = useCallback(time => {
    if (rafActivity.current) {
      rafCallback.current(time);
      raf.current = requestAnimationFrame(step);
    }
  }, []);
  const result = useMemo(() => [() => {
    // stop
    if (rafActivity.current) {
      rafActivity.current = false;
      if (raf.current) {
        cancelAnimationFrame(raf.current);
      }
    }
  }, () => {
    // start
    if (!rafActivity.current) {
      rafActivity.current = true;
      raf.current = requestAnimationFrame(step);
    }
  }, () => rafActivity.current // isActive
  ],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(() => {
    if (initiallyActive) {
      result[1]();
    }
    return result[0];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return result;
}